import PropTypes from 'prop-types';
import withContext from 'react-recompose/withContext';
import hoistStatics from 'react-recompose/hoistStatics';
import { simulateOn, isAnimating } from '@graphistry/viz/src/client/legacy';

export function setupLegacyInterop(document, options) {
    const simulation = getSimulationCanvas(document);

    let {
        socket,
        dataset, session,
        logo: showLogo = true,
        info = true, menu = true,
        top, left, right, bottom,
        play, opacity, pixelRatio,
        ['mix-blend-mode']: mixBlendMode = undefined
    } = options;

    const simCameraBounds = { top, left, right, bottom };

    pixelRatio = pixelRatio || 2;

    if (typeof opacity !== 'undefined' && !isNaN((opacity = Math.abs(parseFloat(opacity))))) {
        if (opacity > 1) {
            opacity = opacity / Math.pow(10, Math.ceil(Math.log10(opacity)));
        }
        simulation.style.opacity = opacity;
    }

    if (typeof mixBlendMode !== 'undefined') {
        simulation.style['mix-blend-mode'] = mixBlendMode;
    }

    simulation.style.top = 0;
    simulation.style.left = 0;
    simulation.style.right = 0;
    simulation.style.bottom = 0;
    simulation.style.width = `100%`;
    simulation.style.height = `100%`;
    simulation.style.position = `absolute`;

    simulateOn.next(true);
    isAnimating.next(false);

    const onPublishedPathUpdated = (v) =>
        options.model.sink.publishedPathUpdatedSubject.next(v);

    return hoistStatics(
        withContext(
            {
                info: PropTypes.bool,
                menu: PropTypes.bool,
                play: PropTypes.number,
                socket: PropTypes.object,
                dataset: PropTypes.string,
                session: PropTypes.string,
                showLogo: PropTypes.bool,
                pixelRatio: PropTypes.number,
                simulation: PropTypes.object,
                onPublishedPathUpdated: PropTypes.func,
                simCameraBounds: PropTypes.object
            },
            () => ({
                info,
                menu,
                play,
                socket,
                dataset,
                session,
                showLogo,
                pixelRatio,
                simulation,
                onPublishedPathUpdated,
                simCameraBounds
            })
        )
    );
}

function getSimulationCanvas(document, simulation) {
    return (simulation =
        document.getElementById('simulation') ||
        ((simulation = document.createElement('canvas')) &&
            (simulation.id = 'simulation') &&
            simulation));
}
